export default __webpack_public_path__ + "static/media/EFT.9bb4c432.svg";